import * as i0 from "@angular/core";
export class GlobalsService {
    constructor() {
        // Local
        // dataUrl = 'http://localhost/salud/';
        // PROD
        this.dataUrl = 'https://saluddigitalprodapi-dycqcpdyhwbsa6dr.eastus2-01.azurewebsites.net/';
        this.sa = 'https://saluddigitalprodstorage.blob.core.windows.net/uploadedfiles';
        // TEST
        // dataUrl = 'https://xworks-salud-be-g8h8b6agd5bweheg.canadacentral-01.azurewebsites.net/';
        // sa = 'https://xworkssa.blob.core.windows.net/uploadedfiles';
        this.fileUrl = this.sa + '/uploadedfiles/';
        this.iconUrl = this.sa + '/icons/';
        this.pwaUrl = 'http://www.xworks.com';
        // fileUrl = this.sa + '/uploadedfiles/';
        this.loginData = {
            access_token: '',
        };
        this.currentRole = '';
        this.messageId = '';
    }
}
GlobalsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GlobalsService_Factory() { return new GlobalsService(); }, token: GlobalsService, providedIn: "root" });
